import React, { createContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import Cookies from 'js-cookie';
import 'react-toastify/dist/ReactToastify.css';

export const GlobalContext = createContext();

export const GlobalProvider = (props) => {
    const navigate = useNavigate();
    const [jobData, setJobData] = useState(null);
    const [jobDetails, setJobDetails] = useState(null);
    const [fetchStatus, setFetchStatus] = useState(true);
    const [currentId, setCurrentId] = useState(-1);
    const [userData, setUserData] = useState(null);
    const [search, setSearch] = useState('');
    const [companyList, setCompanyList] = useState(null);
    const [cityList, setCityList] = useState(null);
    const [userPassword, setUserPassword] = useState(null);
    const [loading, setLoading] = useState(false);
    const [passwordInput, setPasswordInput] = useState({
        current_password: '',
        new_password: '',
        confirm_password: '',
    });
    const [registerInput, setRegisterInput] = useState({
        image_url: '',
        name: '',
        email: '',
        password: '',
    });
    const [loginInput, setLoginInput] = useState({
        email: '',
        password: '',
    });
    const [input, setInput] = useState({
        title: '',
        job_description: '',
        job_qualification: '',
        job_type: '',
        job_tenure: '',
        job_status: 0,
        company_name: '',
        company_image_url: '',
        company_city: '',
        salary_min: 0,
        salary_max: 0,
    });

    const formatSalary = (salary) => {
        const numberFormatter = Intl.NumberFormat('id-ID');
        const formatted = numberFormatter.format(salary);

        return `Rp ${formatted}`;
    };

    const formatText = (text) => {
        if (text !== null)
            return `${text.substring(
                0,
                text.substring(0, 30).lastIndexOf(' ')
            )} ...`;
    };

    // handler functions
    const handleInput = (event) => {
        let value = event.target.value;
        let name = event.target.name;

        setInput({ ...input, [name]: value });
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        let {
            title,
            job_description,
            job_qualification,
            job_type,
            job_tenure,
            job_status,
            company_name,
            company_image_url,
            company_city,
            salary_min,
            salary_max,
        } = input;

        if (currentId === -1) {
            axios
                .post(
                    'https://dev-example.sanbercloud.com/api/job-vacancy',
                    {
                        title,
                        job_description,
                        job_qualification,
                        job_type,
                        job_tenure,
                        job_status,
                        company_name,
                        company_image_url,
                        company_city,
                        salary_min,
                        salary_max,
                    },
                    {
                        headers: {
                            Authorization: 'Bearer ' + Cookies.get('token'),
                        },
                    }
                )
                .then(() => {
                    toast.success('Posted', {
                        theme: 'colored',
                        pauseOnHover: false,
                        draggable: true,
                        autoClose: 2000,
                    });
                    setFetchStatus(true);
                });
        } else {
            axios
                .put(
                    `https://dev-example.sanbercloud.com/api/job-vacancy/${currentId}`,
                    {
                        title,
                        job_description,
                        job_qualification,
                        job_type,
                        job_tenure,
                        job_status,
                        company_name,
                        company_image_url,
                        company_city,
                        salary_min,
                        salary_max,
                    },
                    {
                        headers: {
                            Authorization: 'Bearer ' + Cookies.get('token'),
                        },
                    }
                )
                .then(() => {
                    toast.success('Updated', {
                        pauseOnHover: false,
                        autoClose: 2000,
                        draggable: true,
                        theme: 'colored',
                    });
                    setFetchStatus(true);
                });
        }

        setCurrentId(-1);

        setInput({
            title: '',
            job_description: '',
            job_qualification: '',
            job_type: '',
            job_tenure: '',
            job_status: 0,
            company_name: '',
            company_image_url: '',
            company_city: '',
            salary_min: 0,
            salary_max: 0,
        });
    };

    const handleEdit = (event) => {
        let id = parseInt(event.target.value);

        setCurrentId(id);
        navigate(`/dashboard/job-vacancy-list/form/${id}`);
    };

    const handleDelete = (event) => {
        let id = parseInt(event.target.value);

        axios
            .delete(
                `https://dev-example.sanbercloud.com/api/job-vacancy/${id}`,
                { headers: { Authorization: 'Bearer ' + Cookies.get('token') } }
            )
            .then(() => {
                toast.success('Deleted', {
                    pauseOnHover: false,
                    autoClose: 2000,
                    draggable: true,
                    theme: 'colored',
                });
                setFetchStatus(true);
            });
    };

    const handleLogin = (event) => {
        event.preventDefault();

        let { email, password } = loginInput;

        axios
            .post('https://dev-example.sanbercloud.com/api/login', {
                email,
                password,
            })
            .then((response) => {
                let { token } = response.data;

                setUserPassword(password);
                setUserData(response.data.user);

                Cookies.set('token', token, { expires: 30 });
                Cookies.set('userData', JSON.stringify(response.data.user), {
                    expires: 30,
                });
                toast.success(`Welcome ${response.data.user.name}`, {
                    autoClose: 2000,
                    pauseOnHover: false,
                    draggable: true,
                    theme: 'colored',
                });
                navigate('/');
            })
            .catch(() => {
                toast.error("Account doesn't exist", {
                    autoClose: 2000,
                    pauseOnHover: false,
                    draggable: true,
                    theme: 'colored',
                });
            });
    };

    const handleRegister = (event) => {
        event.preventDefault();

        let { image_url, name, email, password } = registerInput;

        axios
            .post('https://dev-example.sanbercloud.com/api/register', {
                image_url,
                name,
                email,
                password,
            })
            .then((response) => {
                console.log(response);

                toast.success('Registered', {
                    autoClose: 2000,
                    pauseOnHover: false,
                    draggable: true,
                    theme: 'colored',
                });
                navigate('/login');
            })
            .catch(() => {
                toast.error('Error', {
                    autoClose: 2000,
                    pauseOnHover: false,
                    draggable: true,
                    theme: 'colored',
                });
            });

        console.log(registerInput);
    };

    const handleLoginInput = (event) => {
        let value = event.target.value;
        let name = event.target.name;

        setLoginInput({ ...loginInput, [name]: value });
    };

    const handleRegisterInput = (event) => {
        let value = event.target.value;
        let name = event.target.name;

        setRegisterInput({ ...registerInput, [name]: value });
    };

    const handleLogout = () => {
        Cookies.remove('token');
        Cookies.remove('userData');

        toast.success('Logged out', {
            autoClose: 2000,
            pauseOnHover: false,
            draggable: true,
            theme: 'colored',
        });

        navigate('/');
    };

    const handleChangePassword = (event) => {
        event.preventDefault();

        const { current_password, new_password, confirm_password } =
            passwordInput;

        console.log(passwordInput);

        if (current_password !== userPassword) {
            toast.error('Wrong password', {
                autoClose: 2000,
                pauseOnHover: false,
                draggable: true,
                theme: 'colored',
            });
        } else if (new_password !== confirm_password) {
            toast.error('Password confirmation failed', {
                autoClose: 2000,
                pauseOnHover: false,
                draggable: true,
                theme: 'colored',
            });
        } else {
            axios
                .post(
                    'https://dev-example.sanbercloud.com/api/change-password',
                    { new_password, current_password, confirm_password },
                    {
                        headers: {
                            Authorization: 'Bearer ' + Cookies.get('token'),
                        },
                    }
                )
                .then((response) => {
                    console.log(response);

                    toast.success('Password changed', {
                        autoClose: 2000,
                        pauseOnHover: false,
                        draggable: true,
                        theme: 'colored',
                    });

                    setPasswordInput({
                        current_password: '',
                        new_password: '',
                        confirm_password: '',
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    const handleChangePasswordInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        setPasswordInput({ ...passwordInput, [name]: value });
    };

    const handleSearch = (event) => {
        setSearch(event.target.value);

        axios
            .get('https://dev-example.sanbercloud.com/api/job-vacancy')
            .then((response) => {
                setJobData(response.data.data);
                let searchResult = jobData.filter((result) => {
                    return result.title
                        .toLowerCase()
                        .includes(search.toLowerCase());
                });

                setJobData(searchResult);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleReset = (event) => {
        event.preventDefault();

        axios
            .get('https://dev-example.sanbercloud.com/api/job-vacancy')
            .then((response) => {
                setJobData(response.data.data);

                setSearch('');
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleFilter = (event) => {
        const value = event.target.value;
        const name = event.target.name;

        axios
            .get('https://dev-example.sanbercloud.com/api/job-vacancy')
            .then((response) => {
                let data = response.data.data;

                if (value === '') {
                    setJobData(data);
                } else {
                    if (name === 'company') {
                        setJobData(
                            data.filter((result) => {
                                return result.company_name === value;
                            })
                        );
                    } else if (name === 'city') {
                        setJobData(
                            data.filter((result) => {
                                return result.company_city === value;
                            })
                        );
                    } else if (name === 'status') {
                        setJobData(
                            data.filter((result) => {
                                return (
                                    parseInt(result.job_status) ===
                                    parseInt(value)
                                );
                            })
                        );
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    let state = {
        jobData,
        setJobData,
        fetchStatus,
        setFetchStatus,
        input,
        setInput,
        loginInput,
        jobDetails,
        setJobDetails,
        registerInput,
        setRegisterInput,
        userData,
        setUserData,
        userPassword,
        passwordInput,
        setPasswordInput,
        search,
        setSearch,
        companyList,
        setCompanyList,
        cityList,
        setCityList,
        loading,
        setLoading,
    };

    let functions = { formatSalary, formatText };

    let handlers = {
        handleInput,
        handleSubmit,
        handleEdit,
        handleDelete,
        handleLogin,
        handleLoginInput,
        handleLogout,
        handleRegisterInput,
        handleRegister,
        handleChangePassword,
        handleChangePasswordInput,
        handleSearch,
        handleReset,
        handleFilter,
    };

    return (
        <GlobalContext.Provider
            value={{
                state,
                functions,
                handlers,
            }}
        >
            {props.children}
        </GlobalContext.Provider>
    );
};
